import React from "react";
import PropTypes from "prop-types";

const shapes = {
    round: "rounded-[12px]",
    square: "rounded-[0px]",
};

const variants = {
    fill: {
        white_A700: "bg-white-a700 text-blue_gray-600",
    },
    outline: {
        blue_900: "border-blue-900 border-[1.2px] border-solid text-blue-900",
    },
};

const sizes = {
    md: "h-[5.0rem] px-[1.88rem] text-[1.50rem]",
    xs: "h-[2.75rem] px-[1.25rem] text-[1.00rem]",
    sm: "h-[3.00rem] px-[1.25rem] text-[1.00rem]",
};

const Input = React.forwardRef(
    (
        {
            className = "",
            name = "",
            placeholder = "",
            type = "text",
            label = "",
            prefix,
            suffix,
            onChange,
            shape,
            variant = "fill",
            size = "sm",
            color = "white_A700",
            ...restProps
        },
        ref
    ) => {
        return (
            <label
                className={`${className} flex items-center justify-center cursor-text ${shape && shapes[shape]
                    } ${variant && (variants[variant]?.[color] || variants[variant])
                    } ${size && sizes[size]}`}
            >
                {!!label && <span>{label}</span>}
                {!!prefix && <span>{prefix}</span>}
                <input
                    ref={ref}
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    onChange={onChange}
                    className="outline-none bg-transparent flex-1"
                    {...restProps}
                />
                {!!suffix && <span>{suffix}</span>}
            </label>
        );
    }
);

Input.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    prefix: PropTypes.node,
    suffix: PropTypes.node,
    shape: PropTypes.oneOf(["round", "square"]),
    size: PropTypes.oneOf(["md", "xs", "sm"]),
    variant: PropTypes.oneOf(["fill", "outline"]),
    color: PropTypes.oneOf(["white_A700", "blue_900"]),
    onChange: PropTypes.func,
};

Input.displayName = "Input";

export { Input };
